import { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";

//interfaces
import { VerificacionInterface } from "../../../../interfaces/VerificacionInterface";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";
import ServerMessage from "../../../Mensajes/ServerMessage";

//estilos
const classes = require("./VerificacionEdit.module.css").default;

/**
 * UusarioEdit Component
 * @description: Componente que permite editar un verificacion.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de verificacions.
 */

const VerificacionEdit = () => {
  const { idVerificacion } = useParams();
  const { sendRequest, error, setError, serverMessage, setServerMessage } =
    useFetch();
  const [verificacion, setVerificacion] = useState<VerificacionInterface>();
  const [show, setShow] = useState(false);

  //Variables de formulario
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nombre: verificacion?.nombre,
    },
  });

  //Función que trata el detalle de verificacion.
  const transformData = useCallback(
    (variable: any) => {
      setVerificacion(variable.data);
      reset(variable.data);
    },
    [reset]
  );

  //Se recibe el verificacion a editar
  useEffect(() => {
    sendRequest(
      {
        url: `/verificacion/${idVerificacion}`,
      },
      transformData
    );
  }, [idVerificacion, sendRequest, transformData]);

  //Función que solicita la edición del verificacion
  const updateVerificacion = (data: any) => {
    sendRequest(
      {
        url: `/verificacion/${idVerificacion}`,
        method: "PATCH",
        body: data,
      },
      (variable: any) => {
        setShow(true);
      }
    );
  };

  //Mientras se carga el contenido se muestra un spinner
  if (!verificacion) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Edición de la verificación {idVerificacion}</h2>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Verificación actualizada"
          body="La verificación ha sido actualizada de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {/** Error del servidor */}
      {serverMessage && (
        <ServerMessage
          message={serverMessage}
          onCloseHandler={() => setServerMessage(undefined)}
        />
      )}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(updateVerificacion)}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Controller
              name="nombre"
              control={control}
              rules={{
                required: true,
                maxLength: 50,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                El nombre es obligatorio y no puede ser mayor a 50 caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>

        <Button
          style={{
            backgroundColor: "#21618C",
            borderColor: "white",
          }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default VerificacionEdit;
